module.exports = __webpack_public_path__ + "img/bz.81dce14.svg";